// extracted by mini-css-extract-plugin
module.exports = {"buttonLine":"Comment_buttonLine__PT6x7","dotWhite":"Comment_dotWhite__gXKAt"};